import React, { useEffect, useState } from 'react';
import { Badge, InputComponent, Media } from '..';
import { useInputValue } from '../../utils/hooks/useInputValue';
import { TYPES_INVITATIONS } from '../../utils/constants/defaultSponsor';
import { DropAlert, DropColumn, DropLen, DropNew, DropRow, DropTitle, HiddenContainer, HiddenInput, HiddenItem, HiddenItemWrapper } from './styles';

export default ({
  data,
  search,
  onClick,
  mHeigth = '400px',
  checked,
  isEnrolled,
  membershipInfo,
  membershipCount,
}: {
  data: Array<any>;
  mHeigth?: string;
  search?: boolean;
  checked?: string;
  isEnrolled?: boolean;
  membershipInfo?: any;
  membershipCount?: any;
  onClick: (...args: any[]) => void;
}) => {
  const [info, useInfo] = useState(data);
  const filterName = useInputValue('');
  useEffect(() => {
    function FilterData(value: string) {
      useInfo(
        data.filter(
          el =>
            el.title?.toLowerCase()?.includes(value.toLowerCase()) ||
            el.name?.toLowerCase()?.includes(value.toLowerCase()) ||
            el.fullName?.toLowerCase()?.includes(value.toLowerCase()) ||
            el.endDate,
        ),
      );
    }

    FilterData(filterName.value);
  }, [filterName.value, data]);

  function parseDateYearlyMembership(date: string) {
    let nDate = new Date(date);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[nDate.getMonth()] + " " + nDate.getUTCDate() + "-" + String(nDate.getFullYear()).substring(2, 4);
  }

  return (
    <HiddenContainer mHeigth={mHeigth}>
      {search && (
        <HiddenInput>
          <InputComponent dynamicSearch={filterName} />
        </HiddenInput>
      )}
      {membershipInfo ? (<>
        {membershipInfo?.name === TYPES_INVITATIONS.SPONSOR_PLAYER && (
          <>
            {info.map((el, key) => (
              <React.Fragment key={key}>
                {!el.unused && !el.selected && <HiddenItem onClick={() => onClick(el)}>
                  <HiddenItemWrapper>
                    <DropRow>
                      <DropColumn>
                        {el?.endDate && `${el?.remainingPeriod} Remaining`}
                      </DropColumn>
                      <DropColumn>
                        {el?.endDate && `EXP: ${parseDateYearlyMembership(el?.endDate)}`}
                      </DropColumn>
                    </DropRow>
                  </HiddenItemWrapper>
                </HiddenItem>
                }
              </React.Fragment>
            ))}
          </>
        )}
        {(membershipInfo.count > 0 && !isEnrolled ) &&
          <HiddenItem onClick={() => onClick({ name: 'new' })} >
            <HiddenItemWrapper>
              <DropRow>
                <DropColumn>
                  <DropNew>
                    {'New Available'}
                  </DropNew>
                </DropColumn>
                <DropColumn>
                  <DropNew>
                    {membershipInfo.count}
                  </DropNew>
                </DropColumn>
              </DropRow>
            </HiddenItemWrapper>
          </HiddenItem>}
      </>
      ) : membershipCount ? (info.map((el, key) => (
        <React.Fragment key={key}>
          {((membershipCount.yearly >= membershipCount.selected && membershipCount.yearly > 0 && el.value === TYPES_INVITATIONS.SPONSOR_PLAYER) ||
            (el.value !== TYPES_INVITATIONS.SPONSOR_PLAYER)) &&
            <HiddenItem key={key} onClick={() => onClick(el)}>
              <HiddenItemWrapper>
                {!el?.alert ? (
                  <DropTitle>
                    {el?.title || el?.name || el?.fullName}
                    {el?.numberOfPlayers && `EXP: ${parseDateYearlyMembership(el?.endDate)}`}
                  </DropTitle>
                ) : (
                  <DropAlert color={el?.color}>{el?.title || el?.name || el?.fullName || el?.endDate}</DropAlert>
                )}
              </HiddenItemWrapper>
              <div>{el.lenght && <DropLen>({el.lenght})</DropLen>}</div>
            </HiddenItem>}
        </React.Fragment>
      ))
      ) : (info.map((el, key) => (
        <HiddenItem key={key} onClick={() => onClick(el)}>
          <HiddenItemWrapper>
            {el.picture ? (
              <Media imgUrl={el.picture} size="30px" mRight="0" />
            ) : el.badge === 'ALL' ? (
              <Badge color="#007AFF" />
            ) : el.badge ? (
              <Badge text={el.badge} color={el?.color} checked={el?.color === checked} />
            ) : el.initials ? (
              <Badge text={el.initials} color={el?.color} />
            ) : (
              <></>
            )}
            {!el?.alert ? (
              <DropTitle>
                {el?.title || el?.name || el?.fullName}
                {el?.numberOfPlayers && `EXP: ${parseDateYearlyMembership(el?.endDate)}`}
              </DropTitle>
            ) : (
              <DropAlert color={el?.color}>{el?.title || el?.name || el?.fullName || el?.endDate}</DropAlert>
            )}
          </HiddenItemWrapper>
          <div>{el.lenght && <DropLen>({el.lenght})</DropLen>}</div>
        </HiddenItem>
      )))
      }
    </HiddenContainer>
  );
};
